import {
  ControlledSelect,
  ControlledTextField
} from 'components/shared/ControlledFields';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import {
  useGetArrangementsOptions,
  useGetContracts,
  useGetTravelCompensationType
} from '../../../../../queries';
import { toOptions } from 'utils/toOptions';
import { Option } from 'components/shared/ControlledFields/ControlledSelect';

const importProviderOptions = [
  {
    value: 'Bo4',
    label: 'Bo4'
  }
];

const importCountryCodesOptions: Option[] = [
  {
    value: 'NL',
    label: 'NL'
  }
];

export const FormContent = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();

  const { data: travelCompensationType } = useGetTravelCompensationType();
  const arrangementsOptions = useGetArrangementsOptions();
  const { data: contractsOptions } = useGetContracts('code', 'name');

  return (
    <>
      <ControlledSelect
        options={importProviderOptions}
        name="import_travel_import_arrangement_type"
        label={t('importTravelArrangementsSettings.importType')}
        control={control}
      />
      <ControlledTextField
        name="import_travel_arrangement_filePath"
        label={t('importTravelArrangementsSettings.s3FilePath')}
        control={control}
      />
      <ControlledSelect
        options={toOptions(travelCompensationType ?? [], 'id', 'name')}
        name="import_travel_arrangement_compensationTypeId"
        label={t('importTravelArrangementsSettings.importCompensationType')}
        control={control}
      />
      <ControlledSelect
        options={arrangementsOptions ?? []}
        name="import_travel_arrangement_trvSetId"
        label={t('importTravelArrangementsSettings.importTravelSet')}
        control={control}
      />
      <ControlledSelect
        options={importCountryCodesOptions}
        name="import_travel_arrangement_countryCode"
        label={t('importTravelArrangementsSettings.importCountryCode')}
        control={control}
      />
      <ControlledSelect
        options={contractsOptions ?? []}
        name="import_travel_arrangement_contractKindToKeep"
        label={t('importTravelArrangementsSettings.contractKindToKeep')}
        control={control}
      />
    </>
  );
};
